/* HW · Backorder message variant change handler
   Subscribes to Broadcast's variantChange event and updates the
   backorder message text when user picks a different variant.

   Source legacy: hw-livethe/assets/theme.js (variant change handler
   that read window.nonSampleVariants).

   Migrated: 2026-06-03 */
(function () {
  'use strict';

  function initContainer(container) {
    var variantsEl = container.parentElement
      ? container.parentElement.querySelector('[data-hw-backorder-variants]')
      : null;
    if (!variantsEl) return;

    var variants = [];
    try {
      variants = JSON.parse(variantsEl.textContent);
    } catch (e) {
      return;
    }

    function updateForVariant(variantId) {
      var match = variants.find(function (v) {
        return Number(v.id) === Number(variantId);
      });
      if (!match) return;

      var isBackordered = match.backorder && match.backorder !== 'In-stock';
      if (isBackordered && match.message) {
        container.classList.add('is-backorder');
        container.innerHTML = '<p>' + match.message + '</p>';
      } else {
        container.classList.remove('is-backorder');
        container.innerHTML = '';
      }
    }

    function onVariantChange(payload) {
      if (!payload || !payload.data || !payload.data.variant) return;
      updateForVariant(payload.data.variant.id);
    }

    if (window.subscribe && window.theme && window.theme.PUB_SUB_EVENTS) {
      window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, onVariantChange);
    }
  }

  function init() {
    document.querySelectorAll('[data-hw-backorder]').forEach(initContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
